import styled from 'styled-components';

import {
  Divider as SemanticDivider,
} from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent, CenteredLoader, Segment as SegmentLayoutComponent, Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

const Segment = styled(SegmentLayoutComponent)`
  &.ui.segment {
    width: 650px;
    margin-top: 100px;
    margin-left: auto;
    margin-right: auto;
    padding: 30px;
    min-height: 250px;
  }
`;

const Text = styled(TextLayoutComponent)`
  margin-bottom: 5px;
`;

const Title = styled(TextLayoutComponent.Header)`
`;

const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    margin: 40px auto 0;
    display: block;
    min-width: 130px;
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin-top: 100px;
  max-width: 1500px;
  margin-left: auto;
  margin-right: auto;
`;

const ContainerContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 850px;
  min-height: 350px;
`;

const Loader = styled(CenteredLoader)``;

const Divider = styled(SemanticDivider)`
  &&&.ui.divider {
    margin-top: 0px;
  }
`;

const ContainerTree = styled.div``;

export {
  Segment,
  Text,
  Title,
  Button,
  Container,
  Loader,
  ContainerContent,
  Divider,
  ContainerTree,
};
